import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import { css, styled } from '@ori-ui/mui';
import { Markets } from "./helpers";
import { QUICK_BUY_BUTTON_STATE_LOADING, QUICK_BUY_BUTTON_STATE_SUCCESS, QUICK_BUY_BUTTON_STATE_WAITING } from "../../common";
import { IconButton } from "../IconButton";
var getStyleForState = function getStyleForState(_ref) {
  var state = _ref.state,
    theme = _ref.theme;
  switch (state) {
    case QUICK_BUY_BUTTON_STATE_LOADING:
      return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        cursor: default;\n\n        .MuiSvgIcon-root {\n          animation: rotating 1s linear infinite;\n          fill: ", ";\n        }\n      "])), theme.palette.success.main);
    case QUICK_BUY_BUTTON_STATE_SUCCESS:
      return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        cursor: default;\n\n        .MuiSvgIcon-root path {\n          animation: dash 500ms ease forwards;\n          fill: ", ";\n          stroke-dasharray: 32;\n          stroke-dashoffset: -32;\n          stroke-linecap: round;\n          stroke-linejoin: round;\n        }\n      "])), theme.palette.success.main);
    case QUICK_BUY_BUTTON_STATE_WAITING:
      return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        cursor: default;\n        fill: ", ";\n      "])), theme.palette.grey[200]);
    default:
      return null;
  }
};
export var Root = styled(IconButton, {
  name: 'QuickBuyRoot'
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  & svg {\n    fill: ", ";\n  }\n  &:hover {\n    color: ", ";\n    & svg {\n      fill: ", ";\n    }\n  }\n  ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme,
    tenant = _ref2.tenant;
  return tenant === Markets.CN ? theme.palette.superApp.main : theme.palette.text.primary;
}, function (_ref3) {
  var theme = _ref3.theme,
    tenant = _ref3.tenant;
  return tenant === Markets.CN ? theme.palette.superApp.main : theme.palette.text.primary;
}, function (_ref4) {
  var theme = _ref4.theme,
    tenant = _ref4.tenant;
  return tenant === Markets.CN ? theme.palette.superApp.dark : theme.palette.text.secondary;
}, function (_ref5) {
  var theme = _ref5.theme,
    tenant = _ref5.tenant;
  return tenant === Markets.CN ? theme.palette.superApp.dark : theme.palette.text.secondary;
}, getStyleForState);
//# sourceMappingURL=styles.js.map